import { useState } from 'react'
import { Input, Select, Textarea } from '../../components/forms'
import Button from '../../components/ui/Button'

const EMOJI_OPTIONS = [
  '🏢', '💼', '🛒', '🎨', '📱', '💻', '🎮', '📚',
  '🍕', '☕', '🏠', '🚗', '✈️', '🎵', '📸', '🎬',
]

const STATUS_OPTIONS = [
  { value: 'planning', label: 'Planning' },
  { value: 'active', label: 'Active' },
  { value: 'paused', label: 'Paused' },
]

function BusinessForm({ initialData, onSubmit, onCancel, loading = false }) {
  const [formData, setFormData] = useState({
    name: initialData?.name || '',
    description: initialData?.description || '',
    emoji: initialData?.emoji || '🏢',
    status: initialData?.status || 'planning',
    website: initialData?.website || '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // Normalize website URL - add https:// if missing
    const normalizedData = { ...formData }
    if (normalizedData.website && !normalizedData.website.match(/^https?:\/\//i)) {
      normalizedData.website = `https://${normalizedData.website}`
    }
    onSubmit(normalizedData)
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-4">
        <label className="form-label">Icon</label>
        <div className="flex gap-2" style={{ flexWrap: 'wrap' }}>
          {EMOJI_OPTIONS.map(emoji => (
            <button
              key={emoji}
              type="button"
              onClick={() => setFormData(prev => ({ ...prev, emoji }))}
              style={{
                width: '40px',
                height: '40px',
                fontSize: '1.25rem',
                border: formData.emoji === emoji ? '2px solid var(--primary-500)' : '1px solid var(--gray-200)',
                borderRadius: 'var(--border-radius)',
                background: formData.emoji === emoji ? 'var(--primary-50)' : 'white',
                cursor: 'pointer',
              }}
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>

      <Input
        label="Business Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder="My Business"
        required
      />

      <Textarea
        label="Description"
        name="description"
        value={formData.description}
        onChange={handleChange}
        placeholder="Brief description of your business..."
        rows={2}
      />

      <Select
        label="Status"
        name="status"
        value={formData.status}
        onChange={handleChange}
        options={STATUS_OPTIONS}
      />

      <Input
        label="Website"
        name="website"
        type="text"
        value={formData.website}
        onChange={handleChange}
        placeholder="example.com"
      />

      <div className="flex justify-between gap-3 mt-6">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" loading={loading}>
          {initialData ? 'Update' : 'Create'} Business
        </Button>
      </div>
    </form>
  )
}

export default BusinessForm
